import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { prepareHeaders, API, buildError } from '../../api/apis';
import { UpdateLogProfileRequest, DescribeLogProfileRequest } from '../../interfaces/interfaces';

export const logProfileService = createApi({
  reducerPath: 'logProfileApi',
  tagTypes: ['LogProfile'],
  baseQuery: fetchBaseQuery({
    prepareHeaders: prepareHeaders,
  }),
  endpoints: (builder) => ({
    getLogProfile: builder.query({
        query: ({ payload }: { payload: DescribeLogProfileRequest }) => {
          const result = API.FETCH_LOG_PROFILE(payload);
          return result || ''; // Ensure a valid string is returned
        },
        providesTags: () =>  [{ type: 'LogProfile', id: 'LIST' }],
        transformResponse: (response: any) => {
          return response.Response;
        },
        transformErrorResponse: (response) => {
          return buildError(response, "");
        },
    }),
    updateLogProfile: builder.mutation({
      query: ({ payload }: { payload: UpdateLogProfileRequest }) => ({
        url: `${API.UPDATE_LOG_PROFILE(payload)}`,
        method: 'POST',
        body: payload,
      }),
      transformResponse: (response: any) => {
        return response.Response;
      },
      transformErrorResponse: (response) => {
        return buildError(response, "");
      },
      invalidatesTags:[{type: 'LogProfile', id: 'LIST'}]
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useGetLogProfileQuery, useUpdateLogProfileMutation } = logProfileService;
